import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Sora, sans-serif' }}>
            Premier Event Entertainment Rentals in <span className="text-amber-400">Allentown PA</span>
          </h1>
          <p className="text-xl sm:text-2xl text-white/95 mb-8 leading-relaxed max-w-3xl mx-auto">
            Make your celebration unforgettable with bounce houses, interactive games, entertainment, and more. Serving the Lehigh Valley with reliable, on-time service and clean, safe equipment.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link 
              to="/contact" 
              className="bg-red-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-red-700 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap w-full sm:w-auto"
            >
              Get Free Quote Now
            </Link>
            <a 
              href="tel:6102532835" 
              className="bg-white text-red-600 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-50 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-phone-fill mr-2"></i>
              Call (610) 253-2835
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 text-white">
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
              <i className="ri-shield-check-fill text-2xl text-amber-400"></i>
              <span className="font-semibold">Licensed & Insured</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
              <i className="ri-time-fill text-2xl text-amber-400"></i>
              <span className="font-semibold">Same-Day Service Available</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
              <i className="ri-star-fill text-2xl text-amber-400"></i>
              <span className="font-semibold">5-Star Rated</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
}